<template>
  <div>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark>
    <v-toolbar-title style="overflow: unset;">
      <v-app-bar-nav-icon @click="toggleNavigationBar"></v-app-bar-nav-icon>
    </v-toolbar-title>
    <v-toolbar-title :class="['hidden-sm-and-down IMPROVE-logo', { 'text-left': [1, 5].includes(this.$store.getters.companyState) && this.$store.getters.level == 2 && $globalConfig.APP_NAME == 'direct'}]" hide-details>
      <img v-if="$globalConfig.APP_NAME != 'direct' && companyLogo != undefined && companyLogo.length > 0" :class="['logo', shouldApplyHeight ? 'custom-logo' : 'only-padding-top']" :src="companyLogo"  @load="checkImageSize" ref="companyLogo"/>
      <img v-if="$globalConfig.APP_NAME == 'direct' && !companyLogo" :class="['LogoWhite', [1, 5].includes(this.$store.getters.companyState) && this.$store.getters.level == 2 ? 'logo-left'  : 'logo']" src="static/improve-white-logo.png" />
      <img v-if="$globalConfig.APP_NAME == 'direct' && companyLogo != undefined && companyLogo.length > 0" :class="['logo', [1, 5].includes(this.$store.getters.companyState) && this.$store.getters.level == 2 ? 'logo-left'  : '', shouldApplyHeight ? 'custom-logo' : 'only-padding-top']" :src="companyLogo" @load="checkImageSize"  ref="companyLogo" />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <trial-countdown></trial-countdown>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="isLoggedInByPartner" icon class="bell-icon-bg mr-2" @click="signIntoPartner">
          <v-icon v-bind="attrs" v-on="on">fa-sign-in-alt</v-icon>
        </v-btn>
      </template>
      <span>Back to your Hub</span>
    </v-tooltip>
    <img src="/static/resources/top-header-divider.png" alt="Help Icon" class="header-divider" v-if="isLoggedInByPartner">
    <!-- Book a Demo (header button + first-login popup) removed 21 Sep 2026
         (Muhammad). The tour and IMPROVE Live are the demo offer. -->
    <div class="help-icon" v-on:click="redirectOn()" title="Help and Resources">
      <div class="wrapper">
        <v-icon>mdi-help</v-icon>
      </div>
      <!-- <img src="/static/resources/help-and-resources-icon-white.png" alt="Help Icon" v-else /> -->
      <span><b>Help and Resources</b></span>
    </div>
    <img src="/static/resources/top-header-divider.png" alt="Help Icon" class="header-divider">
    
    <span class="help-email hidden-sm-and-down"  v-if="$globalConfig.APP_NAME == 'direct'">
      <a href="mailto:info@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20...">
        Email us: info@improve.online
      </a>
    </span>

    <!-- Notification -->
    <v-btn
      icon
      class="bell-icon-bg ml-md-4"
      @click.stop="toggleNotificationDrawer"
      v-click-outside-el="hideDrawer"
    >
      <v-badge color="red" left overlap>
        <span class="v-badge__badge red" v-if="notificationCount">
          <span>{{ notificationCount }}</span>
        </span>
        <v-icon>mdi-bell</v-icon>
      </v-badge>
    </v-btn>

    <!-- Profile -->
    <v-toolbar-title style="width: 40px;overflow: unset; margin-left:18px;">
      <span>
        <v-btn icon large to="/profile/profile">
          <v-avatar class="profile-image" v-if="companyAvatar">
            <v-img :src="companyAvatar"></v-img>
          </v-avatar>
          <v-avatar class="profile-image" v-else>
            <v-icon large>mdi-account-circle</v-icon>
          </v-avatar>
        </v-btn>
      </span>
    </v-toolbar-title>
    <v-menu transition="slide-y-transition" bottom style="z-index: 20000;">
      <template v-slot:activator="{ on, attrs }">
        <v-toolbar-title v-on="on" v-bind="attrs" style="width: 150px; margin-left:18px;">
            <div style="display: flex;">
            <p class="Name-Surname">
              {{ level }}
            </p>
            <v-icon small style="margin: 0 auto;display: block;">mdi-chevron-down</v-icon>
            </div>
          <p class="Company-Name" :title='companyName'>{{ companyName }}</p>
        </v-toolbar-title>
      </template>
      <v-list style="position:relative;z-index:99;">
        <v-list-item v-for="(item, i) in items" :key="i">
          <v-list-item-title v-if="item.title!='Logout'"><a :href="item.path" style="color: rgba(0, 0, 0, 0.87) !important;">{{ item.title }}</a></v-list-item-title>
          <v-list-item-action @click="logout" v-else style="cursor:pointer;">Logout</v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
    <div v-if="notificationDrawer">
      <notification-drawer :notification-drawer="notificationDrawer" @notifications-read="updateNotificationCount"></notification-drawer>
    </div>
  </div>
</template>

<!--<template>
  <v-toolbar flat>
    <v-toolbar-title>
      <img class="logo" :src="companyLogo" />

    </v-toolbar-title>
    <v-spacer></v-spacer>
    <h4>{{ adminLevel }}</h4>
    <p></p>
    <v-btn v-if="isLoggedInByPartner" icon @click="signIntoPartner">
      <v-icon> fa-sign-in-alt</v-icon>
    </v-btn>
  </v-toolbar>
</template>-->

<script>
import { IMPROVE_CONFIG } from "@/config.js";
import thumbSizes from "@/utils/thumbs.js";
import NotificationDrawer from "@/components/NotificationDrawer";
import TrialCountdown from "@/components/TrialCountdown";
import { EventBus } from "@/event-bus.js";
import Vue from 'vue';

Vue.directive('click-outside-el', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // Check if the clicked element is inside the drawer
      let classArray = ['v-toolbar__content','v-toolbar__title','v-list--three-line','fa-times','clear-notification'];
      if (!(el === event.target || el.contains(event.target) || classArray.some(className => event.target.classList.contains(className)) ) ) {
        // Call the method specified in the directive binding
        vnode.context[binding.expression]();
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});
export default {
  components: {
    NotificationDrawer,
    TrialCountdown,
  },
  props: {
      source: String,
  },
  data: () => ({
    dialog: false,
    drawer: null,
    notificationDrawer: null,
    notificationCount: 0,
    items: [{ title: "My Profile", path:"#/profile/profile" }, { title: "My Password", path:"#/profile/password" }, { title: "Logout", path:"" }],
    confirmLogout: "Are you sure you want to log out?",
    profilePicture: null,
    shouldApplyHeight: true,
  }),
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    getTrialInfo: function() {
      return this.$store.getters.trialDays;
    },
    companyState: function() {
      const state = this.$store.getters.companyState;
      var text = '';
      switch (state) {
        case 1:
          text = "Free Trial";
          break
        case 2:
          text = "Free Trial Expired";
          break
        case 3:
          text = "Active Membership";
          break
        case 4:
          text = "Membership Suspended";
          break
        default:
          text = "";
      }
      return text;
    },
    adminLevel: function() {
      const level = this.$store.getters.level;
      var text = '';
      switch (level) {
        case 1:
          text = "Super Administrator";
          break
        case 2:
          return "Administrator";
          break;
        case 4:
          return "";
          break;
        default:
          text = "";
          break
      }
      return text;
    },
    isLoggedInByPartner: function() {
      if(localStorage.getItem('todos')!="" && localStorage.getItem('todos')!= null) {
        return true;
      } else {
        return false;
      }
    },
    /*companyLogo: function() {
      const level = this.$store.getters.level;
      var logo = this.imgSrc(this.$store.getters.companyLogo.key);
      switch (level) {
        case 1:
          return logo;
          break
        case 2:
          return logo;
          break  
        case 3:
          return logo;
          break
        case 4:
          return logo;
          break
        default:
          return this.$store.getters.companyLogo;
          break
      }
    },*/
    companyAvatar: function() {
      const level = this.$store.getters.level;
      var avatar = this.$store.getters.companyAvatar;
      switch (level) {
        case 2:
          return avatar;
          break  
        default:
          return this.$store.getters.companyAvatar;
          break
      }
    },
    level: function() {
        const user = this.$store.getters.user;
        return user.first_name + " " + user.last_name;
    },
    companyName: function() {
        const user = this.$store.getters.user;
        return user.company ? user.company.data.company_name : '';
    },
    companyLogo: function() {
        if (this.$store.getters.companyLogo.key) {
        // const imageRequest = JSON.stringify({
        //   bucket: `${IMPROVE_CONFIG.BUCKET}`,
        //   key: this.$store.getters.companyLogo.key,
        //   edits: thumbSizes.company_logo
        // });
        // const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
        //   imageRequest
        // )}`;
        const url = this.$store.getters.companyLogo.url;
        return url;
      }
      return '';
    },
  },
  mounted() {
    this.getNotificationCount();
    this.setEventBus();
  },
  methods : {
    signIntoPartner: function() {
      this.$store
        .dispatch("autologin", {
          id:localStorage.getItem('todos')
        })
        .then(() => {
          localStorage.setItem('todos', '');
          this.getProfile();
        })
        .catch(err => {
          this.valid = false;
          this.loading = false;
          this.messages = [];
          let errors = err.response.data.errors;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.errorMessage = errMsg;
            this.$snotify.error(errMsg);
          }
          if (errors) {
            for (let field in errors) {
              this.messages[field] = errors[field];
            }
          }
        });
    },
    getProfile() {
      this.$store
          .dispatch("profile")
          .then(resp => {
            switch (this.$store.getters.level) {

              case 1:
                this.$router.push("/super-admin/companies");
                break;

              case 2:
                this.$router.push("/admin");
                break;
              case 4:
                this.$router.push("/partner/users");
                break;
              case 5:
                this.$router.push("/partner/users");
                break;
              default:
                this.$router.push("/");
                break;
            }
          })
          .catch(err => {
            this.loading = false;
          });
    },
    logout() {
      this.$snotify.confirm(this.confirmLogout, {
        backdrop:0.3,                         
        buttons: [
          { text: "Cancel",className: 'toast-cancel-button', },
          {
             text: "Continue",className: 'toast-continue-button',
             action: toast => this.processLogout()
          }          
        ]
      });
    },
    processLogout: function() {
      this.$snotify.remove();
      const backdrop = document.querySelector('.snotify-backdrop');
      if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
      }
      this.$store.dispatch("logout").then(() => {
        // var elem = document.getElementById("freshchat-js-sdk");
        localStorage.removeItem('todos');
        // if (elem) {
        //   elem.parentNode.removeChild(elem);
        //   this.$router.push("/login");
        //   location.reload();
        // } else {
            this.$router.push("/login");
        // }
      });
    },
    toggleNavigationBar() {
      const vm = this;
      vm.$emit('toggleNavigationBar');
      // if(screen.width<=1262) {
      //   vm.$emit('toggleNavigationBar');
      // }
      document.getElementById('navbar-collapse').style.display='block';
    },
    toggleNotificationDrawer() {
      // Open the notification drawer
      this.notificationDrawer = !this.notificationDrawer;
    },
    getNotificationCount() {
      // Fetch unread notification count
      axios
        .get(IMPROVE_CONFIG.API_URL + "/get-unread-notification-count")
        .then((response) => {
          this.notificationCount = response.data.unread_notification_count;
        });
    },
    setEventBus() {
      EventBus.$on("DRAWER_STATE", payload => {
          this.notificationDrawer = payload;
      });
      EventBus.$on('notifications-read', this.updateNotificationCount);
    },
    hideDrawer(){
      if(this.notificationDrawer){
        this.notificationDrawer = false;
      }
    },
    redirectOn(){
      this.$router.push("/resources");
    },
    updateNotificationCount() {
      this.notificationCount = 0;
    },
    checkImageSize() {
      const img = this.$refs.companyLogo;
      if (img) {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        // Check dimensions and update condition
        if (width < 300 && height < 70) {
          this.shouldApplyHeight = false;
        } else {
          this.shouldApplyHeight = true;
        }
      }
    }
  }
};
</script>
